export default __webpack_public_path__ + "static/media/1.92bb85d2.jpg";